<template>
  <div class="subscribe-page">
    <main>
      <section class="subscribe-hero">
        <img class="subscribe-prize" src="../../static/images/subscribe/prize_txt.png" alt="" />
        <header class="subscribe-header">
          <img src="../../static/images/logo1.png" alt="WowBox" />
        </header>
        <div class="subscribe-scroll">
          <div class="scroll-wrapper">
            <div class="scroll-item" v-for="(item, index) in scrollLightData" :key="index">{{ item }}</div>
          </div>
        </div>
      </section>

      <div class="subscribe-content">
        <div class="subscribe-phone">
          <img class="subscribe-prefix" src="../../static/images/subscribe/09.png" alt="09" />
          <input
            class="subscribe-number"
            :value="mobile"
            :placeholder="$t('landFont1')"
            :aria-label="$t('landFont1')"
            type="tel"
            disabled
          />
        </div>

        <div class="subscribe-plans">
          <button v-if="showDaily" class="subscribe-plan plan-daily" type="button" @click="goSubscribe('daily')">
            <span class="plan-daily-copy">
              <span class="plan-name">{{ $t('Daily') }}<img class="plan-arrow" src="../../static/images/subscribe/arrow.png" alt="" /></span>
              <span class="plan-price plan-price-old">{{ $t('subscribeDailyPrice') }}</span>
            </span>
            <img v-if="$i18n.locale === 'en'" class="plan-free" src="../../static/images/subscribe/free_en.png" alt="" />
            <img v-else class="plan-free" src="../../static/images/subscribe/free_bur.png" alt="" />
          </button>

          <div v-if="showWeekly || showMonth" class="subscribe-secondary-plans">
            <button v-if="showWeekly" class="subscribe-plan plan-secondary plan-weekly" type="button" @click="goSubscribe('weekly')">
              <span class="plan-copy">
                <span class="plan-name">{{ $t('Weekly') }}<img class="plan-arrow" src="../../static/images/subscribe/arrow.png" alt="" /></span>
                <span class="plan-price">{{ $t('subscribeThreeDayPrice') }}</span>
              </span>
            </button>
            <button v-if="showMonth" class="subscribe-plan plan-secondary plan-monthly" type="button" @click="goSubscribe('monthly')">
              <span class="plan-copy">
                <span class="plan-name">{{ $t('Monthly') }}<img class="plan-arrow" src="../../static/images/subscribe/arrow.png" alt="" /></span>
                <span class="plan-price">{{ $t('subscribeMonthlyPrice') }}</span>
              </span>
            </button>
          </div>
        </div>

        <nav class="subscribe-links">
          <button type="button" @click="getChange('termsAndCondition2')">{{ $t('TC') }}</button>
          <button type="button" @click="getChange('faq2')">{{ $t('FAQ') }}</button>
        </nav>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobile: '',
      type: 'daily',
      showWeekly: false,
      showDaily: false,
      showMonth: false,
      scrollLightData: {}
    }
  },
  created() {
    if (this.$route.query.mobile) {
      this.mobile = this.dealPhone_2(this.$route.query.mobile)
    }
    this.setAvailablePlans()
    this.scrollLight()
  },
  methods: {
    setAvailablePlans() {
      let subappid = this.$route.query.subappid
      if (subappid == 'daily'){
        this.showDaily = true
      } else if (subappid == 'weekly'){
        this.showWeekly = true
      } else if (subappid == 'monthly'){
        this.showMonth = true
      } else {
        this.showDaily = true
        this.showWeekly = true
        this.showMonth = true
      }
    },
    goSubscribe(type) {
      let that = this
      this.type = type
      if (that.mobile == '') {
        that.$utils.alertText(that.$t('enderNumber'), 80)
        return;
      }
      let params = new URLSearchParams(this.$route.query)
      params.set('mobile', that.mobile)
      params.set('subappid', that.type)
      that.$parent.loadModal(true)
      that.$api.get('/api/user/get_mobile_subappid_cg?' + params.toString(), {}, r => {
        if (r.code == 1) window.location.href = r.data + '&reg=reg'
        else {
          that.$parent.loadModal(false)
          that.$utils.alertText(r.msg, 80)
        }
      })
    },
    scrollLight() {
      let that = this
      that.$api.post('/api/index/scroll_light', {}, r => {
        that.$parent.returnCode(r, function () {
          that.scrollLightData = r.data
        })
      })
    },
    getChange(type) {
      this.$router.push({path: '/' + type})
    },
    dealPhone(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('0909') && phone.length === 13) {
        phone = phone.substring(3);
      }
      if (phone.startsWith('09') && phone.length === 11) {
        phone = phone.substring(1);
      }
      if (phone.startsWith('099') && phone.length === 12) {
        phone = phone.substring(2);
      }
      return phone;
    },
    dealPhone_2(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('97') && phone.length === 10) {
        phone = phone.substring(1);
      }
      return phone;
    },
  }
}
</script>

<style scoped>
.subscribe-page {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background: #080e36 url(../../static/images/index/main_bg.jpg) no-repeat center top;
  background-size: 100% 100%;
  color: #fff;
  font-family: Atom-sans;
}

.subscribe-hero {
  position: relative;
  width: 100%;
  aspect-ratio: 1125 / 1729;
}

.subscribe-prize {
  position: absolute;
  top: -0.55rem;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
}

.subscribe-header {
  position: absolute;
  z-index: 2;
  top: 0.6rem;
  left: 50%;
  width: 1.6rem;
  transform: translateX(-50%);
}

.subscribe-header img {
  display: block;
  width: 100%;
}

.subscribe-scroll {
  position: absolute;
  z-index: 2;
  top: 2.28rem;
  left: 6%;
  width: 88%;
  height: 0.68rem;
  overflow: hidden;
  border-top: 0.01rem solid rgba(69, 128, 255, 0.4);
  border-bottom: 0.01rem solid rgba(69, 128, 255, 0.4);
  background: linear-gradient(90deg, transparent, #005bdf 48%, transparent);
  font-size: 0.24rem;
  line-height: 0.34rem;
  text-align: center;
}

.scroll-wrapper {
  position: absolute;
  width: 100%;
  animation: scrollUp 60s linear infinite;
}

.scroll-item {
  height: 0.34rem;
  overflow: hidden;
  color: #fff;
  line-height: 0.34rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@keyframes scrollUp {
  from { transform: translateY(0); }
  to { transform: translateY(-100%); }
}

.subscribe-content {
  position: relative;
  z-index: 1;
  margin-top: -0.97rem;
  padding-bottom: 0.48rem;
}

.subscribe-phone {
  width: 4.97rem;
  height: 0.93rem;
  display: flex;
  align-items: center;
  margin: 0 auto;
  background: url(../../static/images/subscribe/phone_input_bg.png) no-repeat center;
  background-size: 100% 100%;
}

.subscribe-prefix {
  display: block;
  width: 1.14rem;
  height: 0.71rem;
  margin-left: 0.09rem;
  object-fit: contain;
}

.subscribe-number {
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 0 0.32rem;
  border: 0;
  background: transparent;
  color: #fff;
  font-family: Atom-sans-bold;
  font-size: 0.38rem;
  letter-spacing: 0;
}

.subscribe-number:disabled {
  opacity: 1;
  -webkit-text-fill-color: #fff;
}

.subscribe-number::placeholder {
  color: #757da9;
  -webkit-text-fill-color: #757da9;
  font-size: 0.28rem;
  opacity: 1;
}

.subscribe-plans {
  margin-top: 0.5rem;
}

.subscribe-plan {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  color: #fff;
  font-family: Atom-sans-bold;
  cursor: pointer;
}

.plan-daily {
  width: 3.85rem;
  height: 1.35rem;
  margin: 0 auto;
  background: url(../../static/images/subscribe/daily_btn_bg.png) no-repeat center;
  background-size: 100% 100%;
  font-size: 0.38rem;
}

.plan-daily-copy {
  width: 2.5rem;
  margin-right: 1.35rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.plan-copy {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.plan-name {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.1;
}

.plan-price {
  margin-top: 0.03rem;
  font-size: 0.22rem;
  line-height: 1.1;
}

.plan-price-old {
  text-decoration: line-through;
}

.plan-free {
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  width: 1.35rem;
  height: 1.35rem;
}

.plan-arrow {
  width: 0.19rem;
  height: 0.31rem;
  margin-left: 0.08rem;
  object-fit: contain;
}

.subscribe-secondary-plans {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  margin-top: 0.38rem;
}

.plan-secondary {
  width: 3.03rem;
  height: 1.03rem;
  font-size: 0.34rem;
  white-space: nowrap;
}

.plan-weekly {
  background: url(../../static/images/subscribe/weekly_btn_bg.png) no-repeat center;
  background-size: 100% 100%;
}

.plan-monthly {
  background: url(../../static/images/subscribe/monthly_btn_bg.png) no-repeat center;
  background-size: 100% 100%;
}

.subscribe-links {
  width: 5rem;
  display: flex;
  justify-content: space-between;
  gap: 0.3rem;
  margin: 0.48rem auto 0;
}

.subscribe-links button {
  min-width: 1.4rem;
  padding: 0;
  border: 0;
  background: none;
  color: #b7b4ea;
  font-family: Atom-sans;
  font-size: 0.27rem;
  text-align: center;
  text-decoration: underline;
  text-underline-offset: 0.05rem;
}
</style>



// WEBPACK FOOTER //
// src/page/subscribe.vue